import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { constrainedProgramsQuery } from '../constants/queries';
import { CustomButton } from '../components/UI/CustomButton';
import { MdEdit } from 'react-icons/md';
import { JSX } from 'react';
import { useToastContext } from '../components/UI/ToastManager';
import dateFormatHelper from '../utils/dateFormat';

export type ConstrainedProgramsQueryResponse = {
  programsConstrained: {
    id: string;
    name: string;
    lastUpdateDate: Date;
  }[];
};

export type ConstrainedProgramsTableItem = {
  id: string;
  name: string;
  date: string;
  actions: JSX.Element;
};

export function useProgramsConstrainedQuery() {
  const { showError } = useToastContext();

  return useQuery<ConstrainedProgramsTableItem[]>({
    queryKey: ['constrainedPrograms'],
    queryFn: () =>
      graphqlRequest<ConstrainedProgramsQueryResponse>(constrainedProgramsQuery, undefined, showError).then(({ programsConstrained }) =>
        programsConstrained.map((program): ConstrainedProgramsTableItem => ({
          ...program,
          date: dateFormatHelper(program.lastUpdateDate),
          actions: (
            <CustomButton visual="ghost" justifyContent="flex-start">
              <MdEdit />
            </CustomButton>
          ),
        }))
      ),
  });
}